import * as numeral from 'numeral';
import 'numeral/locales/pt-br';
import * as _ from 'lodash';

export const pieChartOptions: any = {
  legend: {
    display: true,
  },
  tooltips: {
    enabled: false,
    // callbacks: {
    //   label: (tooltipItem, data) => {
    //     const allData = data.datasets[tooltipItem.datasetIndex].data;
    //     const tooltipLabel = data.labels[tooltipItem.index];
    //     const tooltipData = allData[tooltipItem.index];
    //     let total = 0;
    //     for (let i in allData) {
    //       total += allData[i];
    //     }
    //     const tooltipPercentage = Math.round((tooltipData / total) * 100);
    //     return `${ tooltipLabel }: ${ numeral(tooltipData).format('0,0') } (${ tooltipPercentage }%)`;
    //   }
    // }
  },
  plugins: {
    datalabels: {
      backgroundColor: function (context) {
        return context.dataset.backgroundColor;
      },
      // borderColor: 'white',
      borderRadius: 5,
      // borderWidth: 2,
      padding: 5,
      color: 'white',
      font: {
        size: 14,
        weight: 'bold'
      },
      formatter: function (value, context) {
        let total = 0;
        for (let i in context.dataset.data) {
          total += context.dataset.data[i];
        }
        const percentage = _.round((value / total) * 100, 2);
        return `${ value } (${ numeral(percentage).format('0,0.00') }%)`;
      }
    }
  }
};
